import { get } from 'lodash'
import { CONFIGURATION_KEYS } from '../../constants/enums'

export default function(fields = {}, localeId = 2, configuration) {

  const minAgeCfg = get(configuration, `values[${CONFIGURATION_KEYS.leaderMinAge.id}].intValue`)

  const data = {
    ...fields,
    agreementCodeOfConduct: get(fields, 'agreementCodeOfConduct', false),
    isAgreedToReceivedMarketingMaterialsFromNao: get(
      fields,
      'helpers.marketingFromNao',
      false
    ),
    isAgreedToReceivedMarketingMaterialsFromOa: get(
      fields,
      'helpers.marketingFromOa',
      false
    ),
    isAgreedToReceivedMarketingMaterialsFromIaf: get(
      fields,
      'helpers.marketingFromIaf',
      false
    ),
    isCoordinator: get(fields, 'isCoordinator') === 'yes',
    localeId,
    helpers: undefined,
    hierarchyLevel: undefined,
    minAgeValue: minAgeCfg
  }

  return data
}
